mutation updateCompanySlugByCompany($input: UpdateCompanySlugInput!) {
  updateCompanySlugByCompany(input: $input) {
    id
  }
}
